var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgZoomOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.5 12.75a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5m5.017-1.117a6.5 6.5 0 1 0-.884.884L18.116 19l.884-.884zM11 8.125H4v-1.25h7z",
  clipRule: "evenodd"
})));
export default SvgZoomOut;